export default __webpack_public_path__ + "static/media/testimony1.763492df.jpg";